/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable object-property-newline */
import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import ReactModal from 'react-modal'

import combineClassNames from '../../helpers/combineClassNames';

import useStyles from './modal-style'

ReactModal.setAppElement('#___gatsby')

const getScrollTop = () => (
  Math.abs(window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop)
)

const Modal = ({
  cart,
  children,
  className,
  isOpen,
  overlayClassName,
  title,
  titleClassName,
  ...others
}) => {
  const modifiers = _.pickBy(others, _.isBoolean)

  const styles = useStyles({
    cart,
    ...modifiers,
  })
  const modalClassName = combineClassNames([
    styles.modal,
    modifiers.center && styles.modalCenter,
    modifiers.dialog && styles.modalDialog,
    modifiers.fullPage && styles.modalFullPage,
    modifiers.slide && styles.modalSlide,
    modifiers.innerScroll && styles.modalInnerScroll,
    ..._.castArray(className),
  ])
  const titleStyle = combineClassNames([
    styles.title,
    modifiers.center && styles.titleCenter,
    ..._.castArray(titleClassName),
  ])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currenctScrollTop, setCurrentScrollTop] = useState(0)
  useEffect(() => {
    if (isOpen) {
      const scrollTop = getScrollTop()
      setCurrentScrollTop(scrollTop)
      document.getElementsByTagName('body')[0].setAttribute('style', `top: ${scrollTop * -1}px`)
    }
  }, [isOpen])
  useEffect(() => {
    if (!isModalOpen && currenctScrollTop) {
      // Set page scroll position back to previous position with delay
      _.delay(
        (top) => {
          document.body.scrollTop = top // for safari
          document.documentElement.scrollTop = top // for IE/Firefox/...others
        },
        10,
        currenctScrollTop,
      )
    }
  }, [isModalOpen])
  useEffect(() => {
    if (!_.isEqual(isModalOpen, isOpen)) {
      document.body.classList[isOpen ? 'add' : 'remove']('modal-open')
      if (!isOpen) {
        document.body.removeAttribute('style')
      }
      setIsModalOpen(isOpen)
    }
  })
  useEffect(() => (() => {
    // remove modal-open class from body when componentDidMount
    document.body.classList.remove('modal-open')
    document.getElementsByTagName('body')[0].setAttribute('style', '')
  }), [])
  return (
    <ReactModal
      closeTimeoutMS={cart ? 500 : 0}
      className={modalClassName}
      overlayClassName={
        combineClassNames([
          styles.overlay,
          cart && styles.cartOverlay,
          overlayClassName,
        ])
      }
      isOpen={isModalOpen}
      {...others}
    >
      {!_.isEmpty(title) && (
        <h1 className={titleStyle}>
          {title}
        </h1>
      )}
      {children}
    </ReactModal>
  )
}

Modal.defaultProps = {
  children: false,
  className: '',
  title: '',
  isOpen: false,
  loading: false,
}

export default Modal
